import { popoverAnatomy as parts } from "@chakra-ui/anatomy";
import { cssVar } from "@chakra-ui/react";
export { Popover, PopoverTrigger, PopoverContent, PopoverHeader, PopoverBody, PopoverFooter, PopoverArrow, PopoverCloseButton, PopoverAnchor } from "@chakra-ui/react";
const $popperBg = cssVar('popper-bg');
const $arrowBg = cssVar('popper-arrow-bg');
const $arrowShadowColor = cssVar('popper-arrow-shadow-color');
const baseStylePopper = {
    zIndex: 10
};
const shadowShape = '0px 0px 25px 10px rgb(0 0 0 / 10%), 0 10px 10px -5px rgb(0 0 0 / 4%)';
const shadowShapeDark = '0px 0px 25px 10px rgb(0 0 0 / 40%), 0 10px 10px -5px rgb(0 0 0 / 4%)';
const baseStyleContent = {
    [$popperBg.variable]: 'colors.background.neutral.secondary.default',
    bg: $popperBg.reference,
    [$arrowBg.variable]: $popperBg.reference,
    [$arrowShadowColor.variable]: 'colors.background.neutral.secondary.default',
    width: 'xs',
    border: '0 none',
    borderRadius: 'lg',
    boxShadow: shadowShape,
    zIndex: 'inherit',
    _focus: {
        boxShadow: shadowShape
    },
    _focusVisible: {
        outlineStyle: 'solid',
        outlineWidth: '2px',
        outlineColor: 'border.accent.primary.default',
        outlineOffset: 0,
        boxShadow: shadowShape
    },
    _dark: {
        [$popperBg.variable]: 'colors.background.neutral.secondary.default',
        [$arrowShadowColor.variable]: 'colors.background.neutral.secondary.default',
        boxShadow: shadowShapeDark,
        _focus: {
            boxShadow: shadowShapeDark
        },
        _focusVisible: {
            boxShadow: shadowShapeDark
        }
    }
};
const baseStyleHeader = {
    px: 4,
    py: 3.5,
    borderBottomWidth: '1px'
};
const baseStyleBody = {
    px: 4,
    py: 3.5
};
const baseStyleFooter = {
    px: 4,
    py: 3.5,
    borderTopWidth: '1px'
};
const baseStyleCloseButton = {
    position: 'absolute',
    borderRadius: 'full',
    top: 2.5,
    insetEnd: 2.5,
    padding: 2
};
const baseStyle = {
    popper: baseStylePopper,
    content: baseStyleContent,
    header: baseStyleHeader,
    body: baseStyleBody,
    footer: baseStyleFooter,
    arrow: {
        boxShadow: 'none'
    },
    closeButton: baseStyleCloseButton
};
export const ThemedPopover = {
    parts: parts.keys,
    baseStyle
};

//# sourceMappingURL=Popover.js.map